/**
 * 富文本 HTML 净化工具
 * 用于在 dangerouslySetInnerHTML 前对内容做 XSS 过滤，
 * 保留常规富文本标签/样式，剔除 script、事件属性（onerror/onclick 等）、javascript: 协议等危险内容。
 * @author ritaxxu
 */
import DOMPurify from 'dompurify'

/**
 * 净化富文本 HTML，返回可安全用于 dangerouslySetInnerHTML 的字符串
 * @param html 原始 HTML 内容（可能来自后端/用户输入）
 */
export function sanitizeHtml (html?: string | null): string {
  if (!html) return ''
  return DOMPurify.sanitize(html, {
    // 禁止所有内联事件属性（onerror、onclick 等）
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover'],
    // 禁止 script 等可执行标签
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed'],
  })
}

export default sanitizeHtml
